var _path, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendorActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.499 14.0246L31.7706 8.49474C31.882 8.44834 31.882 8.29058 31.7706 8.24418L25.2851 5.54191L19.543 3.14936C18.8749 2.87096 18.1232 2.87096 17.455 3.14936L5.22744 8.24418C5.11607 8.29058 5.11607 8.44834 5.22744 8.49474L11.7129 11.197L18.499 14.0246Z",
    fill: "#0088CC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_0_1315",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.499 29.8585V14.0242L31.8834 8.44744C31.9728 8.41019 32.0713 8.47588 32.0713 8.57272V23.2986C32.0713 23.8465 31.7418 24.3407 31.2361 24.5514L18.499 29.8585Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.499 29.8585V14.0242L31.8834 8.44744C31.9728 8.41019 32.0713 8.47588 32.0713 8.57272V23.2986C32.0713 23.8465 31.7418 24.3407 31.2361 24.5514L18.499 29.8585Z",
    fill: "#2D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.499 14.0242L18.3685 13.711C18.2421 13.7637 18.1597 13.8873 18.1597 14.0242H18.499ZM18.499 29.8585H18.1597C18.1597 29.972 18.2164 30.0779 18.3108 30.1409C18.4052 30.2038 18.5248 30.2154 18.6295 30.1717L18.499 29.8585ZM31.2361 24.5514L31.3666 24.8646L31.2361 24.5514ZM31.8834 8.44744L32.0139 8.76065V8.76065L31.8834 8.44744ZM18.1597 14.0242V29.8585H18.8383V14.0242H18.1597ZM18.6295 30.1717L31.3666 24.8646L31.1056 24.2382L18.3685 29.5453L18.6295 30.1717ZM32.4106 23.2986V8.57272H31.732V23.2986H32.4106ZM31.7529 8.13424L18.3685 13.711L18.6295 14.3375L32.0139 8.76065L31.7529 8.13424ZM32.4106 8.57272C32.4106 8.23375 32.0657 8.00386 31.7529 8.13424L32.0139 8.76065C31.8798 8.81652 31.732 8.718 31.732 8.57272H32.4106ZM31.3666 24.8646C31.9988 24.6012 32.4106 23.9835 32.4106 23.2986H31.732C31.732 23.7096 31.4849 24.0802 31.1056 24.2382L31.3666 24.8646Z",
    fill: "url(#paint0_linear_0_1315)",
    fillOpacity: 0.7,
    mask: "url(#path-2-inside-1_0_1315)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_0_1315",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.92676 8.57272V23.2986C4.92676 23.8465 5.25621 24.3407 5.76197 24.5514L18.499 29.8585V14.0242L5.11468 8.44744C5.02528 8.41019 4.92676 8.47588 4.92676 8.57272Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.92676 8.57272V23.2986C4.92676 23.8465 5.25621 24.3407 5.76197 24.5514L18.499 29.8585V14.0242L5.11468 8.44744C5.02528 8.41019 4.92676 8.47588 4.92676 8.57272Z",
    fill: "#2D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.499 14.0242H18.8383C18.8383 13.8873 18.756 13.7637 18.6295 13.711L18.499 14.0242ZM18.499 29.8585L18.3685 30.1717C18.4732 30.2154 18.5928 30.2038 18.6872 30.1409C18.7816 30.0779 18.8383 29.972 18.8383 29.8585H18.499ZM5.76197 24.5514L5.63147 24.8646H5.63147L5.76197 24.5514ZM5.11468 8.44744L4.98418 8.76065H4.98418L5.11468 8.44744ZM5.26606 23.2986V8.57272H4.58745V23.2986H5.26606ZM18.1597 14.0242V29.8585H18.8383V14.0242H18.1597ZM18.6295 29.5453L5.89248 24.2382L5.63147 24.8646L18.3685 30.1717L18.6295 29.5453ZM4.98418 8.76065L18.3685 14.3375L18.6295 13.711L5.24518 8.13424L4.98418 8.76065ZM5.26606 8.57272C5.26606 8.718 5.11828 8.81652 4.98418 8.76065L5.24518 8.13424C4.93229 8.00386 4.58745 8.23375 4.58745 8.57272H5.26606ZM4.58745 23.2986C4.58745 23.9835 4.99926 24.6012 5.63147 24.8646L5.89248 24.2382C5.51315 24.0802 5.26606 23.7096 5.26606 23.2986H4.58745Z",
    fill: "url(#paint1_linear_0_1315)",
    fillOpacity: 0.7,
    mask: "url(#path-4-inside-2_0_1315)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_0_1315",
    x: 14.499,
    y: 4.43701,
    width: 21.5723,
    height: 29.4214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1315"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1315",
    result: "effect2_dropShadow_0_1315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1315",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_0_1315"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_0_1315",
    x: 0.926758,
    y: 4.43701,
    width: 21.5723,
    height: 29.4214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1315"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1315",
    result: "effect2_dropShadow_0_1315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1315",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_0_1315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1315",
    x1: 18.8383,
    y1: 11.5926,
    x2: 34.7701,
    y2: 20.2172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1315",
    x1: 5.26606,
    y1: 11.5926,
    x2: 21.1978,
    y2: 20.2172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorActive);
export default __webpack_public_path__ + "static/media/vendor-active.14d8c944d0b95b1823daa0b5b9dd6192.svg";
export { ForwardRef as ReactComponent };